/**
 * 角色多视角模板（管理后台）
 *
 * 角色 / 物品 / 场景 三类资产的视角列表彼此独立，分别走三个端点，
 * 共用 <AngleTemplatesEditor /> 组件渲染。
 */

import { directorAdminApi } from '../../../apps/director/services/directorAdminApi';
import { AngleTemplatesEditor } from './AngleTemplatesEditor';

export default function DirectorAngleTemplatesTab() {
  return (
    <AngleTemplatesEditor
      title="角色多视角模板"
      description={
        '用户在角色详情页生成定妆照时，会从这里加载可选视角。promptSuffix 会拼到角色描述末尾用于生图。\n仅影响"角色"，与物品 / 场景视角独立。'
      }
      placeholderName="名称（如：正面）"
      placeholderSuffix="prompt 后缀，如 ', front view, full body'"
      load={() => directorAdminApi.getAngleTemplates()}
      save={(t) => directorAdminApi.updateAngleTemplates(t)}
    />
  );
}
